import { useCallback, useEffect } from 'react'
import { AvailyEvent } from '@customTypes/Availy'
import { resetDefaultChoice, resetInitialState, setInitialState, useChoiceDispatch } from '@context/ChoiceContext'
import { useVisibilityContext } from '@context/VisibilityContext'
import { setClinicId, setVariant, useConfig, useConfigDispatch } from '@context/ConfigurationContext'
import { clearState, useUpsellDispatch } from '@context/UpsellContext'
import { cleanHashFromUrl } from 'src/utils/cleanHashFromUrl'
import { AppMode } from '@customTypes/Generic'
import listenMessages from 'src/utils/listenMessages'

export const useSetInitialState = (asModal: boolean, appMode: AppMode) => {
  const { isVisible, setIsVisible } = useVisibilityContext()
  const choiceDispatch = useChoiceDispatch()
  const configDispatch = useConfigDispatch()
  const upsellDispatch = useUpsellDispatch()
  const { clinicId } = useConfig()

  const handleParentMsg = useCallback(
    (data) => {
      if (data.type === AvailyEvent.OPEN_MODAL) {
        if (asModal) {
          cleanHashFromUrl(appMode)
          setIsVisible?.(true)
        }
        if (data.payload) {
          if (data.payload.clinicId !== clinicId) {
            choiceDispatch(resetDefaultChoice())
          }

          choiceDispatch(setInitialState(data.payload))
          upsellDispatch(clearState())
          if (data.payload.clinicId) {
            configDispatch(setClinicId(data.payload.clinicId))
          }
          configDispatch(setVariant(data.payload.variant))
        }
      }
    },
    [choiceDispatch, configDispatch, upsellDispatch, clinicId, setIsVisible, appMode, asModal]
  )

  useEffect(() => {
    if (!isVisible) {
      choiceDispatch(resetInitialState())
    }
  }, [isVisible, choiceDispatch])

  useEffect(() => listenMessages(handleParentMsg), [handleParentMsg])
}
